// extracted by mini-css-extract-plugin
export default {"wrapper":"Voucher_wrapper__rG0Hd","formWrapper":"Voucher_formWrapper__EEm1u","col":"Voucher_col__MvwWR"};